import MontuLogo from "@/assets/images/montu-logo-light-background.webp";
import { Box } from "@repo/components/src/ui/box";
import { Button, ButtonText } from "@repo/components/src/ui/button";
import { HStack } from "@repo/components/src/ui/hstack";
import { Image } from "@repo/components/src/ui/image";
import { Pressable } from "@repo/components/src/ui/pressable";
import { Text } from "@repo/components/src/ui/text";
import { Link } from "expo-router";
import { ReactNode } from "react";
import { CREATORS_URL, MONTU_URL } from "./links";

type Props = {
  children: ReactNode;
};

/**
 * The frame of every `/start` page: the logo, «Salir», and the banner for the people
 * who landed here by mistake — a creator looking for work. That exit is permanent on
 * purpose: this funnel is for brands, and a creator must never have to finish it to
 * find their way out.
 */
const StartShell = ({ children }: Props) => (
  <Box className="flex-1 bg-background-50">
    <HStack className="items-center justify-between border-b border-outline-100 bg-background-0 px-margins py-3">
      <Link href={MONTU_URL} asChild>
        <Pressable
          accessibilityLabel="Montu"
          className="h-6 w-24 data-[active=true]:opacity-60"
        >
          <Image
            source={MontuLogo}
            className="relative aspect-[1717/427] h-full w-full"
            contentFit="contain"
            contentPosition="left"
            mantainAspect
            size="none"
            alt="Montu logo"
          />
        </Pressable>
      </Link>
      <Link href={MONTU_URL} asChild>
        <Button action="muted" variant="link" size="sm">
          <ButtonText>Salir</ButtonText>
        </Button>
      </Link>
    </HStack>
    <Box className="items-center bg-brand-50 px-margins py-2">
      <Text size="sm" className="text-center text-typography-600">
        Si eres creador de contenido,{" "}
        <Link href={CREATORS_URL} asChild>
          <Button
            action="brand"
            variant="link"
            size="sm"
            className="inline h-fit"
          >
            <ButtonText className="font-bold">haz click aquí.</ButtonText>
          </Button>
        </Link>
      </Text>
    </Box>
    <Box className="min-h-0 flex-1">{children}</Box>
  </Box>
);

export default StartShell;
